/**
 * Utils for building dropdown/menu-like functionality
 *
 * (for example uses see: Dropdown, MenuExperimental, TextInput)
 */
var findNext = function findNext(curOption, items, direction) {
  var newOption = curOption;

  if (direction === 'Down') {
    for (var i = curOption + 1; i < items.length; i += 1) {
      if (!items[i].disabled) {
        newOption = i;
        break;
      }
    }
  } else {
    // Up
    for (var _i = curOption - 1; _i >= 0; _i -= 1) {
      if (!items[_i].disabled) {
        newOption = _i;
        break;
      }
    }
  }

  return newOption;
};
var isBottom = function isBottom(itemList, index) {
  if (index === itemList.length - 1) {
    return true;
  }

  return false;
};
var isTop = function isTop(itemList, index) {
  if (index === 0) {
    return true;
  }

  return false;
};

export { findNext, isBottom, isTop };
